var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",class:[_vm.$style.Quantity, { [_vm.$style['Quantity--disabled']]: _vm.disabled }]},[_c('button',{class:[
      _vm.$style['Quantity__manipulator'],
      _vm.$style['Quantity__manipulator--decrement'],
      {
        [_vm.$style['Quantity__manipulator--disabled']]: _vm.quantity <= 0
      }
    ],on:{"click":_vm.dec}},[_c('span',{staticClass:"font-semibold"},[_vm._v("-")])]),_c('text-input',{class:_vm.$style['Quantity__field'],attrs:{"type":"number","placeholder":"0","max":_vm.max,"min":_vm.min,"step":1},nativeOn:{"keyup":function($event){return _vm.checkInput.apply(null, arguments)}},model:{value:(_vm.q),callback:function ($$v) {_vm.q=_vm._n($$v)},expression:"q"}}),_c('button',{class:[
      _vm.$style['Quantity__manipulator'],
      _vm.$style['Quantity__manipulator--increment'],
      {
        [_vm.$style['Quantity__manipulator--error']]: _vm.error
      }
    ],on:{"click":_vm.add}},[_c('span',{staticClass:"font-semibold"},[_vm._v("+")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }